"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }


 const UNRESOLVED_REACTOR_LABEL = 'Someone'; exports.UNRESOLVED_REACTOR_LABEL = UNRESOLVED_REACTOR_LABEL
 const CURRENT_USER_REACTOR_LABEL = 'You'; exports.CURRENT_USER_REACTOR_LABEL = CURRENT_USER_REACTOR_LABEL

















 const groupReactions = (
  reactions,
  currentUserKey,
  resolveName,
) => {
  const grouped = new Map()

  reactions
    .slice()
    .sort((a, b) => a.CreatedAt.localeCompare(b.CreatedAt))
    .forEach(reaction => {
      const name = reaction.UserKey === currentUserKey
        ? exports.CURRENT_USER_REACTOR_LABEL
        : _optionalChain([resolveName, 'optionalCall', _ => _(reaction.UserKey)]) || exports.UNRESOLVED_REACTOR_LABEL
      const existing = grouped.get(reaction.Emoji)

      if (existing) {
        existing.count += 1
        existing.isOwn ||= reaction.UserKey === currentUserKey
        existing.reactorNames.push(name)
        existing.reactors.push({ userKey: reaction.UserKey, name })
        return
      }

      grouped.set(reaction.Emoji, {
        emoji: reaction.Emoji,
        count: 1,
        isOwn: reaction.UserKey === currentUserKey,
        reactorNames: [name],
        reactors: [{ userKey: reaction.UserKey, name }],
      })
    })

  return Array.from(grouped.values())
}; exports.groupReactions = groupReactions
